import { render } from "./MainFaq.vue?vue&type=template&id=027627c5"
import script from "./MainFaq.vue?vue&type=script&lang=js"
export * from "./MainFaq.vue?vue&type=script&lang=js"

import "./MainFaq.vue?vue&type=style&index=0&id=027627c5&lang=scss"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__